import React from 'react'
import home from './Home.module.css' 
// import hello from './../../img/hello.svg'
import globe from './../../img/binaryglobe.svg'
import brackets from './../../img/brackets.svg'

const Home = () => {
    
    return (
        <div className={home.Home} id='/'>
            <div className={home.container}>
                <h1 className={home.hello}>Hi, I'm Syed Sadaqhuat Yaseen</h1>
                <h1 >Full Stack Web Developer</h1>
            </div>
    
            <img className={home.brackets} src={brackets} alt="brackets" />
            <img className={home.binaryglobe} src={globe} alt="globe" />
        </div>
    )
}

export {Home}
